// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WS4obnphkSU_uf {
  display: inline-flex;
  margin-left: var(--ds-space-050, 4px);
  animation: bDnSgyjnzPebRp 0.2s ease-in-out;
}
@media print {
  .WS4obnphkSU_uf {
    display: none;
  }
}
.NzveD02HrQkrJH {
  padding: var(--ds-space-0, 0px);
}
.NzveD02HrQkrJH:hover {
  border: none;
  background-color: transparent;
}
@keyframes bDnSgyjnzPebRp {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"copyCommentWrapper": `WS4obnphkSU_uf`,
	"slideFromLeft": `bDnSgyjnzPebRp`,
	"copyLinkButton": `NzveD02HrQkrJH`
};
export default ___CSS_LOADER_EXPORT___;
